import React from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
  Selection,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarSimplesNacionalDs } from "../DataSources";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { anoOptions, mesOptions } from "../utils/date-utils";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import notify from "devextreme/ui/notify";

export default class SimplesNacionalBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtro: {
        cnpj: null,
        mesInicial: null,
        exercicio: null,
        mesFinal: null,
        situacao: 0,
      },
      filtroCorrente: [],
      registrosSelecionados: [],
    };
    this.simplesNacionalDs = criarSimplesNacionalDs();
    this._gridInstance = React.createRef();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.executarProcedimento = this.executarProcedimento.bind(this);

    this.situacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TODOS" },
        { id: 1, descricao: "SEM DIFERENÇA" },
        { id: 2, descricao: "COM DIFERENÇA" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.simNaoOptions = {
      dataSource: [
        { id: 0, descricao: "Sim" },
        { id: 1, descricao: "Não" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  filtrar() {
    notify("Filtrando...", "success", 1000);
  }

  limparFiltro() {
    this.setState({
      filtro: {
        cnpj: null,
        mesInicial: null,
        exercicio: null,
        mesFinal: null,
        situacao: 0,
      },
      allMode: "allPages",
      checkBoxesMode: "onClick",
    });
    this.filtrar();
  }

  executarProcedimento() {
    notify("Executando...", "success", 1000);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="filtro-form"
            formData={this.state.filtro}
            colCount={3}
            labelLocation="top"
          >
            <GroupItem colCount={3} colSpan={3}>
              <SimpleItem dataField="cnpj">
                <Label text="CNPJ" />
              </SimpleItem>

              <SimpleItem
                dataField="mesInicial"
                editorType="dxSelectBox"
                editorOptions={mesOptions}
              >
                <Label text="Mês Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="exercicio"
                editorType="dxSelectBox"
                editorOptions={anoOptions}
              >
                <Label text="Exercício" />
              </SimpleItem>
              <SimpleItem
                dataField="situacao"
                editorType="dxSelectBox"
                editorOptions={this.situacaoOptions}
              >
                <Label text="Situação" />
              </SimpleItem>
              <SimpleItem
                dataField="mesFinal"
                editorType="dxSelectBox"
                editorOptions={mesOptions}
              >
                <Label text="Mês Final" />
              </SimpleItem>

              <SimpleItem
                dataField="exercicio"
                editorType="dxSelectBox"
                editorOptions={anoOptions}
              >
                <Label text="Exercício" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar
          titulo="Acompanhamento de Simples Nacional"
          ocultarNovo={true}
        >
          <DataGrid
            //dataSource={this.simplesNacionalDs}
            ref={(grid) => (this._gridInstance = grid)}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            selectedRowKeys={this.registrosSelecionados}
          >
            <Selection
              mode="multiple"
              selectAllMode="allPages"
              showCheckBoxesMode="always"
            />
            <Editing
              allowDeleting={false}
              allowUpdating={false}
              useIcons={true}
              visible={false}
            />
            <Column
              dataField={"cnpj"}
              visibleIndex={0}
              alignment="center"
              allowEditing={false}
              caption={"CNPJ"}
              width={80}
            />
            <Column
              dataField={"competencia"}
              dataType={"date"}
              caption={"Competência"}
            />
            <Column dataField={"nome"} />
            <Column dataField={"valorDeclarado"} />
            <Column dataField={"valorFaturado"} />
            <Column dataField={"situacao"} caption={"Situação"}>
              <Lookup
                dataSource={this.situacaoOptions.dataSource}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
        <br />
        <br />
        <form onSubmit={this.filtrar}>
          <Form
            id="filtro-form"
            formData={this.state.filtro}
            colCount={2}
            labelLocation="top"
          >
            <GroupItem caption="Procedimentos" colCount={2} colSpan={2}>
              <SimpleItem
                dataField="notificar"
                editorType="dxSelectBox"
                editorOptions={this.simNaoOptions}
              />
              <SimpleItem
                dataField="bloquear"
                caption="Bloquear NFS-e"
                editorType="dxSelectBox"
                editorOptions={this.simNaoOptions}
              />
              <SimpleItem
                dataField="mensagemBloqueio"
                editorType="dxTextArea"
                colSpan={2}
                editorOptions={{ height: "100px" }}
              />
            </GroupItem>
          </Form>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={200}
                text="Executar Procedimento"
                type="success"
                onClick={this.executarProcedimento}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}
